/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * User-selectable caption background fills. Values are rgba() strings so the
 * selection carries both color and opacity.
 */
export enum ClosedCaptionBackgroundColor {
  SemiTransparentBlack = "rgba(0, 0, 0, 0.75)",
  SolidBlack = "rgba(0, 0, 0, 1)",
  SemiTransparentWhite = "rgba(255, 255, 255, 0.75)",
  Transparent = "rgba(0, 0, 0, 0)"
}
